import { codeSplit, Controller, FetchOptions, Result, AnalyticsStore } from 'bernie-core';
import { PageData } from 'bernie-http';
import { UiStore } from 'stores';

// util
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

export class PartnerPerfController implements Controller {
  public pageId = pageNames.partnerPerf;
  public path = '/:localeName/analytics';
  public routeName = 'programs';
  public bundles = [];

  public exact = true;

  public component = codeSplit(() => import(/* webpackChunkName: "programs-page" */ '../views/partner-perf-page'));

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, query, request } = options;

    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const context = request.context;

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Analytics' }) as Promise<PageData>;
  }
}
